import BaseModel from "./base/baseModel";
import TipoTemplateWhatsApp from "./enum/TiposTemplateWhatsApp";

export default class TemplateWhatsAppModel extends BaseModel {
    id?: number = null;
    texto = "";
    tipo: TipoTemplateWhatsApp = null;
    tipoDescricao = "";
}
